const auditLogTutorial = {
  module: 'audit_log',
  moduleName: 'Audit Log',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Audit Log', description: 'Complete history of all actions taken in your security system.' },
    { target: '.btn-secondary', position: 'bottom', title: 'Export', description: 'Download the audit trail as CSV for compliance reporting.' },
  ],
};
export default auditLogTutorial;
